import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite} from "gsap";
import {DirtyWildsSpineAnimationNames} from "../../config/DirtyWildsSpineAnimationNames";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsStateReelSymbol} from "./DirtyWildsStateReelSymbol";


/**
 * Class description
 *
 * Created: 2018-09-25
 * @author jonas
 */
export class DirtyWildsWildStateReelSymbol extends DirtyWildsStateReelSymbol {
    private _spine:PIXI.spine.Spine;
    private _animName:string;


    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }


    protected initAnimations():void {
        super.initAnimations();
        let _this = this;
        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.WILD_SYMBOL_SPINE));
        this._spine.autoUpdate = true;
        // if(this._animName === DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_WILD_TRANSFORM){
        //     this._controller.moveSymbolToTopLayer(this)
        // }
        if(this._animName !== "") {
            this._spine.state.setAnimation(0, this._animName, false);
        }
        this._spine.state.addListener({
            start : function(entry) {
                switch(entry.animation.name) {
                    case DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_WILD_LAND:
                        _this._spine.state.setAnimation(0, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_FIRE_LOOP, true);
                        break;
                    case DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_MULTIPLIER_ATTENTION:
                        _this._spine.state.setAnimation(0, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_FIRE_LOOP, true);
                        break;
                }
            },
            complete : function(entry) {
                switch(entry.animation.name) {
                    case DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_COOL_DOWN:
                        // _this._spine.state.setAnimation(0, "idle_wild_yellow", false);
                        break;
                    case DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_IGNITE:
                        _this._spine.state.setAnimation(0, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_FIRE_LOOP, true);
                        _this._spine.state.setAnimation(1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_FIRE_LOOP, true);
                        break;
                }
            }
        });
        this.addChild(this._spine);
    }

    public replaceWith(newName:string, reelId:number, state?:ISymbolStateConfig):Timeline | null {
        this._animName = (state && state.keyword === DirtyWildsGameConfig.instance.SYMBOL_STATES.sticky.keyword) ? "" : "idle_wild_yellow";
        if(DirtyWildGameModuleConfig.overlayController.isRestoreState()) {
            this._animName = "idle_wild_yellow";
        }
        return super.replaceWith(newName, reelId, state);
    }


    protected getStateTl(state:string, stateAnimation:TimelineSprite):TimelineLite {

        const stateTl:TimelineLite = new TimelineLite();

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            return super.getStateTl(state, stateAnimation);
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.win.keyword) {
            return super.getStateTl(state, stateAnimation);
        }
        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.individualWin.keyword) {
            return super.getStateTl(state, stateAnimation);
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            return super.getStateTl(state, stateAnimation);
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.stickyInitial.keyword) {
            stateTl.add(() => this._spine.state.setAnimation(0, "idle_wild_yellow", false));
            stateTl.add(() => this._spine.state.setAnimation(1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_FIRE_LOOP, true));
            stateTl.add(() => this._spine.visible = true);
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }


        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.coolDown.keyword) {
            // stateTl.add(() => this._controller.moveSymbolToAttentionLayer(this));
            if(this.speedUpCoolDown) {
                stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_COOL_DOWN_FAST));
                this.speedUpCoolDown = false;
            } else {
                stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_COOL_DOWN));
            }

        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.attention.keyword) {
            stateTl.add(() => this._controller.moveSymbolToAttentionLayer(this));
            stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_MULTIPLIER_ATTENTION));
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.wildLand.keyword) {
            stateTl.add(() => this._controller.moveSymbolToAttentionLayer(this));
            stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_WILD_LAND));
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.wildGreen.keyword) {
            stateTl.add(() => this._spine.state.setAnimation(0, "idle_wild_sticky", false));
            // stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.ignite.keyword) {
            stateTl.add(() => this._controller.moveSymbolToAttentionLayer(this));
            stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_IGNITE));
            stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }

        if(state === DirtyWildsGameConfig.instance.SYMBOL_STATES.wildTransform.keyword) {
            stateTl.add(() => this._controller.moveSymbolToAttentionLayer(this));
            stateTl.add(new SpineTween(this._spine, 1, DirtyWildsSpineAnimationNames.WILD_SYMBOL_SPINE_WILD_TRANSFORM));
            // stateTl.add(() => this._controller.moveSymbolToTopLayer(this));
        }

        return stateTl;

    }

}